// extracted by mini-css-extract-plugin
module.exports = {"left":"e_fs","sidebar":"e_gs","content":"e_hs","container":"e_is"};